import { useSocketTopicSubscription } from '../hooks';
export const SubscribeSocketTopic = (props) => {
    useSocketTopicSubscription(props);
    return null;
};
//# sourceMappingURL=SubscribeSocketTopic.js.map